export class Location {
  constructor() {
    this.id = "";
    this.name = "";
    this.description = "";
    this.category = "";
    this.categoryName = "";
    this.telephoneNumber = "";
    this.emailAddress = "";
    this.location = null;
    this.fullAddress = "";
    // this.openingTime = "";
    // this.closingTime = "";
    this.rating = null;
    this.createdBy = "";
    this.createdByRole = "";
    this.createdByUsername = "";
    this.createdAt = "";
    this.updatedAt = "";
  }
}
